import React, { useState } from 'react';
import styled from 'styled-components'
import SchemaRender from './schemaRender';
import Logo from './canadaLogo';
import {
  DesktopOutlined,
  FileOutlined,
  PieChartOutlined,
  DatabaseOutlined,
  TeamOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Button,Breadcrumb, Layout, Menu, theme,Typography,Divider,Space,Row,Col,Modal,Alert } from 'antd';
import getSchema  from './schema';
import Language,{useLanguage} from './language'
import Home from './home'
import Faq from './faq'

const { Header, Content, Footer, Sider } = Layout;

const MyLayout = styled(Layout)`
  .ant-layout-header {
  height: auto;
  }
`;
const { Title,Text } = Typography;

const LogoC = styled.div`
background:white;
height: 25px;

`;
const Flag = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMinYMin meet"
    viewBox="0 0 40 20"
    {...props}
  >
    <defs>
      <style>{".fip_text{fill:#000}"}</style>
    </defs>
    <path
      id="sig"
      d="M41.5 21.8h-9.9V2.2h9.9v19.6zM21.8 3.7s-1.2 2.4-1.4 2.6c-.2.3-.3.3-.6.2-.3-.2-1.3-.7-1.3-.7s.9 3.9.9 4.2c.1.3-.2.6-.6.3-.1-.1-1.8-2-1.8-2s-.4.9-.5 1.1c-.1.2-.2.3-.4.2-.3-.1-1.9-.4-1.9-.4s.6 1.9.7 2.2c.1.2.2.4-.2.6l-.6.2s3.3 2.9 3.4 3c.2.2.3.2.2.7-.2.5-.3 1.1-.3 1.1s3.1-.7 3.4-.7c.3 0 .6.1.6.4 0 .3-.2 3.7-.2 3.7h1s-.2-3.3-.2-3.7c0-.3.3-.4.6-.4.3.1 3.4.7 3.4.7s-.2-.7-.3-1.1c-.2-.5 0-.6.2-.7.1-.1 3.4-3 3.4-3l-.6-.2c-.3-.2-.2-.4-.2-.6.1-.2.7-2.2.7-2.2s-1.6.3-1.9.4c-.2.1-.3-.1-.4-.2-.1-.2-.5-1.1-.5-1.1s-1.7 2-1.8 2c-.3.2-.7 0-.6-.3 0-.3.9-4.2.9-4.2s-1 .6-1.3.7c-.2.2-.4.2-.6-.2 0-.3-1.2-2.6-1.2-2.6zm-9.9 18.1V2.2H2v19.6h9.9z"
      style={{
        fill: "red",
      }}
      transform="translate(-2 -2)"
    />
  </svg>
)

const MySpace = styled(Space)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  // margin: 0 24px 0;
  // border-bottom: solid 1px rgba(0,0,0,0.1);
`
const LogoFont = styled.p`
  white-space: pre-line;
  color:white;
  font-family:helvetica;
  font-weight: bold;
  line-height: 1.4;
  font-size: 0.8em;
  padding:0;
  margin:0;
   
`;

function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}
const items = [
  getItem('Emissions', '1', <DatabaseOutlined  />),
  // getItem('Option 2', '2', <DesktopOutlined />),
  // getItem('User', 'sub1', <UserOutlined />, [
  //   getItem('Tom', '3'),
  //   getItem('Bill', '4'),
  //   getItem('Alex', '5'),
  // ]),
  // getItem('Team', 'sub2', <TeamOutlined />, [getItem('Team 1', '6'), getItem('Team 2', '8')]),
  // getItem('Files', '9', <FileOutlined />),
];
const DATA_KEY="PEIT";
const App = ({data:_data}) => {
  const [isHome, setIsHome] = useState(true);
  const [data, setData] = useState(JSON.parse(localStorage.getItem(DATA_KEY)) || []); // Initialize with the stored value
  const [current, setCurrent] = useState('home');
  const [open,setOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  const {lng,setLng}=useLanguage();
  React.useEffect(() => {
    document.title = 'PEIT';
  }, []);
  
  React.useEffect(() => {
    localStorage.setItem(DATA_KEY, JSON.stringify(data));    
  }, [data]);
  
  const {
    token: { headerColor,bodyBg },
  } = theme.useToken();
  
  const items = [
  {
    label: <Language id="Home"/>,
    key: 'home',
  
  },
  {
    label: <Language id={"about"} />,
    key: 'faq',
 
  }
 
];
  const [id, setId] = React.useState();  
  const schema = getSchema({lng})
  const departments=[
      {en:"Government of Canada",fr:"Gouvernement du Canada",width:"70px",marginRight:"10px",marginLeft:"0px"},      
      
      
      ]
      
    const onClick = (e) => {
    
    setCurrent(e.key);
  };
  return (
  isHome?<Home onClick={(lng)=>{setLng(lng);setIsHome(false)}}/>:
    <MyLayout
      style={{
        minHeight: '100vh',
      }}
    >
      <Header
      
       style={{
            padding: 0,
            paddingTop: 5,
            background: headerColor,
            // textAlign: 'center',
            lineHeight:0,
  color: '#fff',
  // height: 64,
  // paddingInline: 48,
  // lineHeight: '64px',
  // backgroundColor: '#4096ff',
          }}
       c
      >
       <Row>
          <MySpace style={{width: "100%"}}>
           
            
            <Row style={{flexWrap:"nowrap",overflow:"hidden",paddingLeft:20}}>
            
            <Logo lng={lng} flagOnly={true} theme={{logoTextColor:bodyBg,logoColor:"red"}}/>
                {departments.map((d,i)=>lng=="en"?
                  [<Col key={i+"a"}  flex={d.width} style={{marginRight:d.marginRight,marginLeft:"10px"}}><LogoFont >{d['en']}</LogoFont></Col>,<Col key={i+"c"}  flex={d.widthfr || d.width } style={{marginRight:d.marginRight,marginLeft:d.marginLeft}}><LogoFont>{d['fr']}</LogoFont></Col>]:
                  [<Col key={i+"b"}  flex={d.widthfr || d.width} style={{marginRight:d.marginRight,marginLeft:"10px"}}><LogoFont>{d['fr']}</LogoFont></Col>,<Col key={i+"d"} flex={d.width} style={{marginRight:d.marginRight,marginLeft:d.marginLeft}}><LogoFont>{d['en']}</LogoFont></Col>]
                  )}
                  </Row>
           
          
          <MySpace>
            <Text ellipsis style={{color:"white"}}>Version : 2026-03-25</Text>
            <Button type="link" onClick={()=>setLng(lng=="en"?"fr":"en")}> <Language id={"lng"}/></Button>
            
          </MySpace>
          </MySpace>
          </Row>
          <Row>
           <MySpace style={{width: "100%"}}>
          <Title level={4} style={{margin:0,color:"white",padding:"5px 20px"}}>
            <Language id="title"/>
          </Title>
           <div style={{width: 200,lineHeight: "30px"}}>
           <Menu  theme="dark" onClick={onClick} selectedKeys={[current]} mode="horizontal" items={items} />
           </div>
          </MySpace>
          </Row>
         </Header>
      {/*<Sider collapsible collapsed={collapsed} onCollapse={(value) => setCollapsed(value)}>        
        <Menu theme="dark" defaultSelectedKeys={['1']} mode="inline" items={items} />
      </Sider>*/}
      <Layout>
        
        
        
        {current=="home"?<Content          style={{            margin: '0 16px',          }}  ><SchemaRender id={id} setId={setId} schema={schema} data={data} setData={setData}/> </Content>:<Faq lng={lng}/>}
         
        
        <Footer
          style={{
            textAlign: 'center',
          }}
        >
          <Language id="created"/>
        </Footer>
      </Layout>
      <Modal title={"NOTICE"} open={open} onCancel={()=>setOpen(false)} onOk={()=>setOpen(false)} ><Alert message={<Language id="alert" />} type="info" showIcon></Alert></Modal>
    </MyLayout>
 
  );
};
export default App

// withRedux(App,[{prop:"app",path:"app"},{prop:"user",path:"user"},{prop:"dataParameters",path:"dataParameters"},{prop:"dataList",path:"dataList"}],[{prop:"setDataList",path:"setDataList"},{prop:"setDataParameters",path:"setDataParameters"}]);